import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { FormsModule as NgFormsModule } from '@angular/forms';

// *******************************************************************************
// NgBootstrap

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

// *******************************************************************************
// App

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { AppService } from './app.service';
import { LayoutModule } from './layout/layout.module';

// *******************************************************************************
// Pages

import { HomeComponent } from './home/home.component';
import { Page2Component } from './page-2/page-2.component';
import { Page3Component } from './page3/page3.component';
import {AuthenticationLoginAndRegisterComponent} from './authentication-login-and-register/authentication-login-and-register.component';
import {StateService} from './state.service';
import { CreateCertificateComponent } from './create-certificate/create-certificate.component';
import {DropzoneModule} from 'ngx-dropzone-wrapper';
import {SweetAlert2LoaderService, SweetAlert2Module} from '@sweetalert2/ngx-sweetalert2';
import Swal from "sweetalert2";
import { ViewCertificateComponent } from './view-certificate/view-certificate.component';
import { ProfessionalListComponent } from './professional-list/professional-list.component';
import { FilterPipe } from './filter.pipe';
import { StatisticsPageComponent } from './statistics-page/statistics-page.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { CandidatePageComponent } from './candidate-page/candidate-page.component';
import { VacancyPageComponent } from './vacancy-page/vacancy-page.component';
import { VacancyDetailPageComponent } from './vacancy-detail-page/vacancy-detail-page.component';
import { ConnectionPageComponent } from './connection-page/connection-page.component';
import { CoursesOverviewPageComponent } from './courses-overview-page/courses-overview-page.component';

// *******************************************************************************
//

export async function provideSwal() {
  return Swal.mixin({
    buttonsStyling: false,
    customClass: {
      confirmButton: 'btn btn-lg btn-primary',
      cancelButton: 'btn btn-lg btn-default'
    }
  });
}

@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,

    // Pages
    HomeComponent,
    Page2Component,
    Page3Component,
    AuthenticationLoginAndRegisterComponent,
    CreateCertificateComponent,
    ViewCertificateComponent,
    ProfessionalListComponent,
    FilterPipe,
    StatisticsPageComponent,
    CandidatePageComponent,
    VacancyPageComponent,
    VacancyDetailPageComponent,
    ConnectionPageComponent,
    CoursesOverviewPageComponent
  ],

  imports: [
    CommonModule,
    NgFormsModule,
    BrowserModule,
    NgbModule,

    // App
    AppRoutingModule,
    // PagesBlankModule,
    LayoutModule,
    DropzoneModule,
    SweetAlert2Module.forRoot({ provideSwal }),

    // Charts
    NgxChartsModule,
    BrowserAnimationsModule
  ],

  providers: [
    Title,
    AppService,
    StateService
  ],

  bootstrap: [
    AppComponent
  ]
})
export class AppModule {}
